import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const tiers = [{
  name: 'Starter',
  monthly: 0,
  annual: 0,
  blurb: 'For teams wiring up their first sources.',
  cta: 'Start free',
  highlight: false,
  features: ['Up to 3 sources', '100k signals / mo', '2 dashboards', 'Slack alerts', 'Community support']
}, {
  name: 'Growth',
  monthly: 99,
  annual: 79,
  blurb: 'For scaling revenue teams that live in the data.',
  cta: 'Start free trial',
  highlight: true,
  features: ['Up to 12 sources', '5M signals / mo', 'Unlimited dashboards', 'Multi-touch attribution', 'Audience sync', 'Priority support']
}, {
  name: 'Scale',
  monthly: null,
  annual: null,
  blurb: 'For enterprises with governance needs.',
  cta: 'Talk to sales',
  highlight: false,
  features: ['Unlimited sources', 'Unlimited signals', 'SSO & role-based access', 'Warehouse sync (Snowflake)', 'Dedicated CSM', 'SLA & security review']
}];
export function Pricing() {
  const [annual, setAnnual] = useState(true);
  return <section id="pricing" className="bg-white py-20 md:py-28" data-id="element-131">
      <div className="mx-auto max-w-[1200px] px-5 md:px-8" data-id="element-132">
        <div className="flex flex-col items-center text-center" data-id="element-133">
          <h2 className="font-display text-4xl font-semibold leading-[1.05] tracking-tight md:text-6xl" data-id="element-134">
            Pricing that scales with your signal.
          </h2>
          <div className="mt-8 inline-flex items-center gap-3 rounded-full border border-ink/15 bg-cream p-1.5" data-id="element-135">
            <button onClick={() => setAnnual(false)} className={`rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${!annual ? 'bg-ink text-cream' : 'text-ink/60'}`} data-id="element-136">
              Monthly
            </button>
            <button onClick={() => setAnnual(true)} className={`rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${annual ? 'bg-ink text-cream' : 'text-ink/60'}`} data-id="element-137">
              Annual
              <span className="ml-1.5 text-signal" data-id="element-138">−20%</span>
            </button>
          </div>
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-3" data-id="element-139">
          {tiers.map((tier, i) => {
          const price = annual ? tier.annual : tier.monthly;
          return <motion.div key={tier.name} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className={`flex flex-col rounded-3xl border p-8 ${tier.highlight ? 'border-transparent bg-ink text-cream' : 'border-ink/15 bg-cream'}`} data-id="element-140">
                {tier.highlight && <span className="mb-4 inline-flex w-fit items-center rounded-full bg-signal px-3 py-1 text-xs font-semibold uppercase tracking-widest text-white" data-id="element-141">
                    Most popular
                  </span>}
                <h3 className="font-display text-2xl font-semibold" data-id="element-142">
                  {tier.name}
                </h3>
                <p className={`mt-1 text-sm ${tier.highlight ? 'text-cream/60' : 'text-ink/60'}`} data-id="element-143">
                  {tier.blurb}
                </p>
                <div className="mt-6 flex items-baseline gap-1" data-id="element-144">
                  {price === null ? <span className="font-display text-4xl font-semibold" data-id="element-145">
                      Custom
                    </span> : <>
                      <span className="font-display text-5xl font-semibold" data-id="element-146">
                        ${price}
                      </span>
                      <span className={tier.highlight ? 'text-cream/50' : 'text-ink/50'} data-id="element-147">
                        /mo
                      </span>
                    </>}
                </div>

                <a href="#cta" className={`mt-6 rounded-full py-3 text-center text-sm font-semibold transition-colors ${tier.highlight ? 'bg-signal text-white hover:bg-signal-dark' : 'bg-ink text-cream hover:bg-signal'}`} data-id="element-148">
                  {tier.cta}
                </a>

                <ul className="mt-8 space-y-3" data-id="element-149">
                  {tier.features.map(f => <li key={f} className="flex items-start gap-3 text-sm" data-id="element-150">
                      <CheckIcon className={`mt-0.5 h-4 w-4 flex-shrink-0 ${tier.highlight ? 'text-signal' : 'text-signal'}`} data-id="element-151" />
                      <span className={tier.highlight ? 'text-cream/80' : 'text-ink/70'} data-id="element-152">
                        {f}
                      </span>
                    </li>)}
                </ul>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}